export async function genCode(api, rCode) {
  //인증번호생성(4자리)
  const numbers = '0123456789';
  const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  let code;
  let rtnCode;

  // 앞의 두 자리는 숫자로 선택
  code = numbers.charAt(Math.floor(Math.random() * numbers.length)) +
    numbers.charAt(Math.floor(Math.random() * numbers.length));

  // 뒤의 두 자리는 영어로 선택
  code += characters.charAt(Math.floor(Math.random() * characters.length)) +
    characters.charAt(Math.floor(Math.random() * characters.length));


  rtnCode = rCode + code;

  return rtnCode;
}

// 일반코드번호 생성
export async function generateCouponCode(api, cpToday, cpQty) {
  const MAX_RETRY = 1000;
  const CODE_LENGTH = 8;
  const characters = '0123456789';
  
  // 쿠폰 코드 생성 함수
  const generateCode = () => {
    return Array.from({ length: CODE_LENGTH }, () => 
      characters[Math.floor(Math.random() * characters.length)]
    ).join('');
  };

  // 메인 로직
  for (let attempt = 1; attempt <= MAX_RETRY; attempt++) {
    const randomPart = generateCode();
    const cpCode = cpToday + randomPart;

    // 중복 체크
    const checkDubCoupon = await api("/api/checkDubCoupon", { param: [cpCode] });

    if (checkDubCoupon.length === 0) {
      // 중복 없을 경우 저장
      const result = await api("/api/ins_coupon_qty", {param: [cpCode, cpQty]});
      
      return result.affectedRows > 0 ? cpCode : (alert("저장 오류 발생"), false);
    }
  }
  return "noCpCode";
}

// 멤버십 전용쿠폰 코드생성
export async function generateCouponCode_mem(api, cpToday) {
  const MAX_RETRY = 1000;
  const CODE_LENGTH = 8;
  const characters = '0123456789';

  const generateCode = () => {
    return Array.from({ length: CODE_LENGTH }, () =>
      characters[Math.floor(Math.random() * characters.length)]
    ).join('');
  };

  let cpCode_mem = '';

  for (let attempt = 1; attempt <= MAX_RETRY; attempt++) 
  {
    const randomPart = generateCode();
    cpCode_mem = cpToday + randomPart;

    // 중복 체크
    const checkDubCoupon = await api('/api/checkDubCoupon_mem', { param: [cpCode_mem] });

    // 중복이면 다시 시도
    if (checkDubCoupon.length > 0) {
      continue;
    }

    // 중복이 아니면 바로 리턴
    return cpCode_mem;
  }

  // 여기까지 왔다는 건 전부 중복이었다는 뜻
  throw new Error('쿠폰 코드 생성에 실패했습니다. (1000회 시도가 중복)');
}
